import React, { useState, useEffect } from "react";
import { api } from "../services/api";

export interface CategoriaProduto {
  id?: number;
  nome: string;
  descricao?: string;
  ativo: boolean;
}

interface CategoriaFormProps {
  categoria?: CategoriaProduto;
  onSave: () => void;
  onCancel: () => void;
}

const CategoriaForm: React.FC<CategoriaFormProps> = ({
  categoria,
  onSave,
  onCancel,
}) => {
  const [formData, setFormData] = useState<CategoriaProduto>({
    nome: "",
    descricao: "",
    ativo: true,
  });
  const [loading, setLoading] = useState(false);

  // 🔹 Preenche campos no modo edição
  useEffect(() => {
    if (categoria) {
      setFormData(categoria);
    }
  }, [categoria]);

  // 🔹 Atualiza os campos do formulário
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // 🔹 Envia o formulário (POST ou PUT)
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.nome.trim()) {
      alert("O nome da categoria é obrigatório.");
      return;
    }

    setLoading(true);
    try {
      if (categoria?.id) {
        await api.put(`/CategoriaProduto/${categoria.id}`, formData);
      } else {
        await api.post("/CategoriaProduto", formData);
      }

      onSave();
    } catch (error) {
      console.error("Erro ao salvar categoria:", error);
      alert("Erro ao salvar categoria. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card shadow-sm mb-4">
      <div className="card-body">
        <h4 className="card-title mb-3">
          {categoria ? "Editar Categoria" : "Nova Categoria"}
        </h4>

        <form onSubmit={handleSubmit}>
          {/* Nome */}
          <div className="mb-3">
            <label className="form-label">Nome *</label>
            <input
              type="text"
              className="form-control"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
              maxLength={100}
              placeholder="Digite o nome da categoria"
            />
          </div>

          {/* Descrição */}
          <div className="mb-3">
            <label className="form-label">Descrição</label>
            <textarea
              className="form-control"
              name="descricao"
              value={formData.descricao || ""}
              onChange={handleChange}
              maxLength={255}
              placeholder="Descrição (opcional)"
              rows={3}
            />
          </div>

          {/* Checkbox Ativo */}
          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="ativoCheck"
              name="ativo"
              checked={formData.ativo}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="ativoCheck">
              Categoria ativa
            </label>
          </div>

          {/* Botões */}
          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={loading}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading
                ? "Salvando..."
                : categoria
                ? "Salvar Alterações"
                : "Cadastrar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoriaForm;
